module.exports = __webpack_public_path__ + "img/service-zhinengyingxiao1.4e994a0e.svg";